import React from 'react';
import Cards from './homeDependencies/cards';
import Contest from './homeDependencies/contest';
import Festivals from './homeDependencies/festival';
import News from './homeDependencies/news';
import Wallets from './homeDependencies/wallets';

const Home = () => {
	return (
		<>
			<Wallets />
			<Contest />
			<Festivals />
			<div className='row g-4'>
				<Cards />
				<News />
			</div>
		</>
	);
};

export default Home;
